import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ModalP2pAddDonationsService } from '../../services/modal-p2p-add-donations/modal-p2p-add-donations.service';
import { ModalP2pEditService } from '../../services/modal-p2p-edit/modal-p2p-edit.service';
import { deleteP2PItem } from '../../features/p2p.actions';
import { CommonModule } from '@angular/common';
import { ModalP2pMoveTransactionsService } from 'app/manage-p2p/services/modal-p2p-move-transactions/modal-p2p-move-transactions.service';
import { selectFundraiserReport } from 'app/manage-p2p/features/p2p.selectors';
import { ModalFullfillAllDonorsService } from 'app/manage-p2p/services/modal-fullfill-all-donors/modal-fullfill-all-donors.service';
import { ToastService } from 'app/toast/services/toast.service';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ModalP2pDowloadQRCardsService } from 'app/manage-p2p/services/modal-p2p-dowload-qr-cards/modal-p2p-dowload-qr-cards.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalAddP2pMilestoneService } from 'app/manage-p2p/services/modal-p2p-add-milestone/modal-add-p2p-milestone.service';

let id = 1;

@Component({
  standalone:true,
  selector: 'app-p2p-details-popover',
  templateUrl: './p2p-details-popover.component.html',
  styleUrls: ['./p2p-details-popover.component.scss'],
  imports:[MdbPopoverModule,CommonModule]
})
export class P2pDetailsPopoverComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public fundraiserReport$: any = this.store.pipe(
    select(selectFundraiserReport)
  );
  
  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() data;
  @Input() campaignId;

  private _id = id++;
  
  get id() {
    return `P2PPopoverEvent_${this._id}`;
  }

  public isModalOpen = false;

  public userExelData = null;
  public fileName = '';

  public exportBtnClasses = {
    'popover__action--disabled': false
  };

  public deleteBtnClasses = {
    'popover__action--disabled': true
  };

  public moveTransactionsClasses = {
    'popover__action--disabled': true
  };

  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  constructor(
    private popoverService: PopoverService,
    private peerToPeerManageService: PeerToPeerManageService,
    private modalP2pAddDonationsService: ModalP2pAddDonationsService,
    public modalP2pEditService: ModalP2pEditService,
    public modalFullfillAllDonorsService: ModalFullfillAllDonorsService,
    public modalP2pMoveTransactionsService:ModalP2pMoveTransactionsService,
    private modalP2pDowloadQRCardsService: ModalP2pDowloadQRCardsService,
    private store: Store,
    public router: Router,
    private toastService: ToastService,
    private modalService: MdbModalService,
    private modalAddP2pMilestoneService: ModalAddP2pMilestoneService
    
  ) { }

  ngOnInit(): void {
    const transactions = this.data.transactions || [];
    if(!transactions.length) {
      this.exportBtnClasses['popover__action--disabled'] = true;
      this.deleteBtnClasses['popover__action--disabled'] = false;
    }

    this.fundraiserReport$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((donorReport)=> {
      if(donorReport.length == 1 ){
        this.moveTransactionsClasses['popover__action--disabled'] = true;
        return
      }else if(!transactions.length){
        this.moveTransactionsClasses['popover__action--disabled'] = true;
        return
      }else{
        this.moveTransactionsClasses['popover__action--disabled'] = false;
      }
    })
  }

  p2pEditModalOpen(){
    this.isModalOpen = true;

    const modalRef = this.modalP2pEditService.open(this.data);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pEditService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  p2pAddDonationsModalOpen(){
    this.isModalOpen = true;

    const modalRef = this.modalP2pAddDonationsService.open(this.data);
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddDonationsService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  notifyFundraiser() {
    const fundraiserName = this.data.createdByName || this.data.userInfo.name;
    const type = "sendFundraisersProgressReminder";
    let params = {
      campaignId: this.campaignId,
      p2pId: this.data.id,
    }


    const title = `Send reminder to ${fundraiserName}`
    const message = `Send fundraiser progress update to ${fundraiserName}.`
    window['orgMain'].showSendSimpleReminderModal(title, message, params, type) 
    return;
    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `Send fundraiser progress update to <b>${this.data.createdByName || this.data.userInfo.name}</b>.`,
        onClose: (status)=>{
          this.modalRef.close();
          if(status){
            this.peerToPeerManageService.notify(this.campaignId, this.data.id).pipe(
              takeUntilDestroyed(this.destroyRef)
            ).subscribe(() => {
              this.toastService.show('success', 'Reminder sent!', {delay: 1500});
            });
          }
        }
      }
    });
    
  }

  exportToExel() {
    this.userExelData = this.peerToPeerManageService.getUserExcelData(this.data.transactions);
    this.fileName = `${this.data.transactions[0].peerToPeerInfo.displayName}_report`

    this.peerToPeerManageService.exportToExcel(this.userExelData, this.fileName)
  }

  p2pMoveTransactionModalOpen(){
    this.isModalOpen = true;

    const modalRef = this.modalP2pMoveTransactionsService.open(this.data);

    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pMoveTransactionsService.modalRef = null;
      this.isModalOpen = false;
    })

  }

  fulfillDonorsPledges(){
    this.isModalOpen = true;
    const modalRef = this.modalFullfillAllDonorsService.open(this.data);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalFullfillAllDonorsService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  addMilestone() {
    this.isModalOpen = true;
    const modalRef = this.modalAddP2pMilestoneService.open(this.data);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalAddP2pMilestoneService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  downloadQrCardsByUser(){
    this.peerToPeerManageService.getDownloadQRCardsByUser(this.campaignId, this.data.id).subscribe((data:any)=>{
      this.isModalOpen = true;

      const options = {
        header: `Download Fundraiser QR Codes for ${this.data.displayName}`,
      }
      const modalRef = this.modalP2pDowloadQRCardsService.open({fileName: data.fileName, options});
      
      modalRef.onClose.pipe().subscribe(() =>{
        this.modalP2pDowloadQRCardsService.modalRef = null;
        this.isModalOpen = false;
      })
    });
  }

  deleteUser() {
    const transactions = this.data.transactions || [];
    let title = '';
    let message = '';

    if(transactions.length){
      title = 'This fundraiser has transactions';
      message = `Please move all transactions from <b>${this.data.createdByName || this.data.userInfo.name}'s</b> P2P fundraiser.`;
      return window['orgMain'].confirmDialogSimpleMd(title, message).then(()=>{
        this.p2pMoveTransactionModalOpen();
      }) .catch((error) => { })
    }

    title = "Are you sure?";
    message = `Delete <b>${this.data.createdByName || this.data.userInfo.name}'s</b> P2P fundraiser.<br> Donations to this fundraiser will not be deleted.`;
    return window['orgMain'].confirmDialogSimpleMd(title, message).then((asd)=> {
      this.store.dispatch({
        type: deleteP2PItem.type,
        payload: this.data.id
      });
    })
    .catch((error) => { })
  }
  
  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }
}
